<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-2"><router-link  to="/">{{$t('terms.breadcrumb_1')}}</router-link></li>
            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item  mx-2 almarai-bold" aria-current="page">{{$t('terms.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
  <!-- begin:Terms and Conditions Agreement -->
  <div class="row pt-3">
    <div class="col terms-condtitions">
      <h5>{{$t('terms.title_1')}}</h5>
      <h6>{{$t('terms.title_2')}}</h6>
      <div class="text-center py-2 almarai-bold">{{$t('terms.title_3')}}</div>
      <!-- <ul>
        <li>{{$t('terms.title_4')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_6')}} ( <span>{{$t('terms.title_7')}}</span> {{$t('terms.title_8')}} <span >{{$t('terms.title_5')}}</span>{{$t('terms.title_9')}}</li>
        <li> {{$t('terms.title_10')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_11')}} <span >{{$t('terms.title_5')}}</span> {{$t('terms.title_12')}}</li>
        <li>{{$t('terms.title_13')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_14')}} <span>{{$t('terms.title_15')}}</span> {{$t('terms.title_16')}} <span >{{$t('terms.title_5')}}</span> {{$t('terms.title_17')}}</li>
      </ul> -->

      <ul class="introduction">
        <li>{{$t('terms.introduction')}}</li>
        <li>{{$t('terms.introduction_1')}}</li>
      </ul>

      <h6 class="py-2 almarai-bold">{{$t('terms.title_18')}}</h6>
      <ul class="definitions">
        <!-- <li><span>{{$t('terms.title_7')}}</span>{{$t('terms.title_19')}}</li>
        <li>
          <span>{{$t('terms.title_5')}}</span>
          {{$t('terms.title_20')}}
          <ul>
            <li>{{$t('terms.title_21')}} <span>{{$t('terms.title_22')}}</span> {{$t('terms.title_23')}} iOS</li>
            <li>{{$t('terms.title_21')}} <span>{{$t('terms.title_22')}}</span> {{$t('terms.title_24')}}</li>
            <li>{{$t('terms.title_25')}} <span>{{$t('terms.title_22')}}</span> {{$t('terms.title_26')}} (https://www.amaqaria.com)</li>
          </ul>
        </li>
        <li class="almarai-bold"> {{$t('terms.title_27')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_28')}} </li> -->
        <li>{{$t('terms.definitions')}}</li>
        <li>{{$t('terms.definitions_1')}}</li>
        <li>{{$t('terms.definitions_2')}}</li>
        <li>{{$t('terms.definitions_3')}}</li>
        <li>{{$t('terms.definitions_4')}}</li>
      </ul>

      <h6 class="py-2 almarai-bold"> {{$t('terms.title_29')}} </h6>
      <ul class="GeneralProvisions">
        <!-- <li>
          {{$t('terms.title_30')}}
        </li>
        <li>
          {{$t('terms.title_31')}}
        </li>
        <li>
          {{$t('terms.title_32')}} <span>{{$t('terms.title_15')}}</span> {{$t('terms.title_33')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_34')}} {{$t('terms.title_15')}} {{$t('terms.title_35')}} <span >{{$t('terms.title_5')}}</span>.
        </li> -->
        <li>{{$t('terms.articleOne')}}</li>
        <li>{{$t('terms.articleOne_1')}}</li>
        <li>{{$t('terms.articleOne_2')}}</li>
        <li>{{$t('terms.articleOne_3')}}</li>
      </ul>
      <h6 class="py-2 almarai-bold"> {{$t('terms.title_36')}} </h6>
      <!-- <h6>{{$t('terms.title_37')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_38')}} </h6> -->
      <ul class="GeneralProvisions">
        <!-- <li>
          {{$t('terms.title_39')}}
        </li>
        <li>
          {{$t('terms.title_40')}} <span >{{$t('terms.title_5')}}</span> {{$t('terms.title_41')}} <span >{{$t('terms.title_5')}}</span> {{$t('terms.title_42')}}
        </li>
        <li>
          {{$t('terms.title_43')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_44')}} <span>{{$t('terms.title_5')}}</span>.
        </li>
        <li> {{$t('terms.title_45')}} </li>
        <li>
          {{$t('terms.title_46')}} <span>{{$t('terms.title_5')}}</span>  {{$t('terms.title_47')}}
        </li>
        <li>
          {{$t('terms.title_48')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_49')}}
        </li>
        <li>{{$t('terms.title_50')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_51')}}</li>

        <li>
          {{$t('terms.title_52')}}
          <span>{{$t('terms.title_5')}}</span> 
        </li>

        <li>
          {{$t('terms.title_53')}} 
          <span>{{$t('terms.title_5')}}</span> 
          {{$t('terms.title_54')}}
        </li>
        <li>
          {{$t('terms.title_55')}} 
          <span>{{$t('terms.title_5')}}</span> 
          {{$t('terms.title_56')}} 
          <span>{{$t('terms.title_5')}}</span> 
          {{$t('terms.title_57')}} 
          <span>{{$t('terms.title_5')}}</span> 
          {{$t('terms.title_58')}} 
          <span>{{$t('terms.title_5')}}</span> 
          {{$t('terms.title_59')}}
        </li>
        <li>
          {{$t('terms.title_60')}}
        </li>
        <li>
          {{$t('terms.title_61')}}
        </li>
        <li>
          {{$t('terms.title_62')}}<span>{{$t('terms.title_5')}}</span>.
        </li>
        <li>
          {{$t('terms.title_63')}} <span>{{$t('terms.title_15')}}</span> {{$t('terms.title_64')}} <span>{{$t('terms.title_15')}}</span>.
        </li>
        <li>
          {{$t('terms.title_65')}} <span>{{$t('terms.title_15')}}</span> {{$t('terms.title_66')}} <span>{{$t('terms.title_15')}}</span>.
        </li>
        <li>
          {{$t('terms.title_67')}} <span>{{$t('terms.title_15')}}</span> {{$t('terms.title_68')}} <span >{{$t('terms.title_5')}}</span> {{$t('terms.title_69')}}
        </li>
        <li>
          {{$t('terms.title_70')}}
          <span> {{$t('terms.title_71')}} </span>
          {{$t('terms.title_72')}}
        </li> -->
        <li>{{$t('terms.articleTwo')}}</li>
        <li>{{$t('terms.articleTwo_1')}}</li>
        <li>{{$t('terms.articleTwo_2')}}</li>
        <li>{{$t('terms.articleTwo_3')}}</li>

      </ul>

      <h6 class="almarai-bold py-2"> {{$t('terms.articleThree')}} </h6>
      <!-- <h6> {{$t('terms.title_74')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_75')}} </h6> -->
      <ul class="GeneralProvisions">
        <!-- <li> {{$t('terms.title_76')}} </li>
        <li> {{$t('terms.title_77')}} <span >{{$t('terms.title_5')}}</span> {{$t('terms.title_78')}} </li>
        <li> {{$t('terms.title_79')}} </li>
        <li> {{$t('terms.title_80')}} </li>
        <li> {{$t('terms.title_81')}} </li> -->
        <li>{{$t('terms.articleThree_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2"> {{$t('terms.articleFour')}} </h6>
      <!-- <h6> {{$t('terms.title_83')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_75')}}</h6> -->
      <ul class="GeneralProvisions">
        <!-- <li> {{$t('terms.title_84')}} </li>
        <li> {{$t('terms.title_85')}} </li>
        <li> {{$t('terms.title_86')}} </li>
        <li> {{$t('terms.title_87')}} </li> -->
        <li>{{$t('terms.articleFour_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2"> {{$t('terms.articleFive')}} </h6>
      <!-- <h6> {{$t('terms.title_89')}} <span> {{$t('terms.title_90')}} </span> {{$t('terms.title_75')}} </h6> -->
      <ul class="GeneralProvisions">
        <!-- <li> {{$t('terms.title_91')}} </li>
        <li>
          {{$t('terms.title_92')}} 
          <span> {{$t('terms.title_90')}} </span>
          {{$t('terms.title_93')}}
          <span>{{$t('terms.title_15')}}</span> {{$t('terms.title_94')}}
        </li>
        <li>
          {{$t('terms.title_95')}}
        </li>
        <li>
          {{$t('terms.title_96')}} <span>{{$t('terms.title_5')}}</span> {{$t('terms.title_97')}}
        </li> -->
        <li>{{$t('terms.articleFive_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2"> {{$t('terms.articleSix')}} </h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleSix_1')}}</li>
        <li>{{$t('terms.articleSix_2')}}</li>
        <li>{{$t('terms.articleSix_3')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleSeven')}}</h6>
      <ul class="GeneralProvisions">
        <!-- <li>
          يحق لـ <span>{{$t('terms.title_5')}}</span> رفض أي طلب استرجاع لأي مبلغ بعد الدفع(تشمل على سبيل المثال لا الحصر: الباقات والترقيات والتمييز والاشتراكات والرسوم) ، مع استثناء الحالات التالية:
          <ul class="GeneralProvisions">
            <li>مبالغ الحجوزات في خدمة <span>(الحجز اليومي)</span> تحكمها سياسة الإلغاء للوحدة المحجوزة.</li>
            <li>
              يحق لك طلب نقل باقات الإعلانات العقارية لمستخدم آخر خلال (5) أيام من تاريخ الدفع.
            </li>
          </ul>
        </li>
        <li>
          يستغرق إرجاع المبالغ المدفوعة بعد الموافقة على طلب الإرجاع 14 يوم عمل.
        </li>
        <li>
          عند طلب استرجاع أي مبلغ مدفوع فإنك توافق على تحمل أي رسوم تتحملها <span>{{$t('terms.title_15')}}</span> على إرجاع المبلغ (على سبيل المثال لا الحصر: رسوم الحوالات أو رسوم بوابات الدفع).
        </li> -->
        <li>{{$t('terms.articleSeven_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleEight')}}</h6>
      <!-- <h6>سعيًا من <span>{{$t('terms.title_15')}}</span> لرفع مستوى وجودة الخدمة المقدمة لمستخدمي <span>{{$t('terms.title_5')}}</span>، وتبعًا لاستخدامك هذه الشروط والأحكام فإنك توافق و تعطي <span>{{$t('terms.title_15')}}</span> الحق في تطبيق أي من الإجراءات التالية دون سابق إنذار إذا تقرر لديها أنك خرقت اتفاقية الشروط والأحكام الخاصة بـ<span>{{$t('terms.title_5')}}</span>:</h6> -->
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleEight_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleNine')}}</h6>
      <!-- <h6>عند استخدامك <span>{{$t('terms.title_5')}}</span> فإنك تفهم وتوافق على الآتي:</h6> -->
      <ul class="GeneralProvisions">
        <!-- <li>
          لا تقدم <span>{{$t('terms.title_15')}}</span> أي ضمانات ولا تتحمل أي مسؤولية في حالة عدم التزام <span>{{$t('terms.title_71')}}</span> باتفاقية الشروط والأحكام ولا نتحمل المسؤولية عن أي مخاطرة أو أضرار أو تبعات أو خسائر تقع عليه أو على أي طرف آخر.
        </li>
        <li>
          لا تقدم <span>{{$t('terms.title_15')}}</span> أي ضمان أو تتحمل أية مسؤولية عن دقة أو اكتمال أو صحة أي من المعلومات الواردة في المحتوى المنشور على ( <span>{{$t('terms.title_5')}}</span> من قبل (المستخدمين)، ولا مدى التزامه بالأنظمة والقوانين المطبقة ذات العلاقة، ويتحمل.
        </li>
        <li>
          لا تتحمل <span>{{$t('terms.title_15')}}</span> في أي حال من الأحوال المسؤولية عن أية أضرار (بما في ذلك -دون حصر-: التعويض عن فقدان البيانات أو الأرباح، أو انقطاع الأعمال) التي تنشأ من استخدام أو عدم القدرة على استخدام المحتوى والمواد على <span>{{$t('terms.title_5')}}</span>.
        </li>
        <li>
          لا تتحمل <span>{{$t('terms.title_15')}}</span> أي مسؤولية تجاه عن أية خسارة أو ضرر، ناشئ أو يتعلق بالآتي:
          <ul class="GeneralProvisions">
            <li>
              أية عطل بسبب البرنامج أو أخطاء في شبكة الإنترنت أو عدم التوفر أو أي أسباب أخرى خارجة عن إرادتنا المعقولة.
            </li>
            <li>
              أي فقدان لكلمة المرور أو الحساب إذا كان بسبب انقطاع الكهرباء أو حدوث خطأ بها أو توقفها أو بسبب نظام الكمبيوتر الخاص بك أو الحساب الخاص بك الاعتماد على أي محتوى أو معلومات تم عرضها على <span>{{$t('terms.title_5')}}</span>،
            </li>
            <li>
              أي خسارة مباشرة أو تبعية أو خاصة أو جزائية أو ضرر أو تكاليف أو نفقات أو خسارة أرباح أو خسارة أعمال أو خسارة الشهرة أو تراجع الشهرة أو فقد البيانات أو تلفها أو فسادها.
            </li>
          </ul>
        </li> -->
        <li>
          {{$t('terms.articleNine_1')}}
        </li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleTen')}}</h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleTen_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleEleven')}}</h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleEleven_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleTwelve')}}</h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleTwelve_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleThirteen')}}</h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleThirteen_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleFourteen')}}</h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleFourteen_1')}}</li>
      </ul>

      <h6 class="almarai-bold py-2">{{$t('terms.articleFifteen')}}</h6>
      <ul class="GeneralProvisions">
        <li>{{$t('terms.articleFifteen_1')}}</li>
      </ul>

      
    </div>
  </div>
  <!-- end:Terms and Conditions Agreement -->
  </div>
</template>
<script>
export default {
  name: "terms",
  data(){
    return {
      userLang: "ar",
    }
  },
  created(){
    window.scroll(0,0);
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}

</script>